import { i18n } from '@lingui/core'

// Import compiled messages (they're in CommonJS format)
const enMessages = require('./locales/en/messages').messages;
const plMessages = require('./locales/pl/messages').messages;
// Hebrew is disabled until RTL layout issues are addressed.
// const heMessages = require('./locales/he/messages').messages;

i18n.load('en', enMessages);
i18n.load('pl', plMessages);
// i18n.load('he', heMessages);
i18n.activate('en');

export { i18n } 
